module.exports = __webpack_public_path__ + "img/s_2.c5571ab0.jpg";